import programs from "./programs";

export const expo = {
    programs,
};

export default expo;
